<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.application' : 'misc.edition.application') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="applicationForm" *ngIf="applicationForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="code">{{'attribute.code' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="code" type="text" formControlName="code" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="url">{{'attribute.url' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="url" type="text" formControlName="url" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.color' | transloco}} (*)</label>
        </div>
        <div class="flex col-12 md:col-4 with-margin-bottom">
          <label [style.background-color]="applicationForm.get('color').value" class="theme-picker cursor-pointer">
            <input formControlName="color" type="color">
          </label>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.icon' | transloco}} (*)</label>
        </div>
        <div class="col-12 md:col-4 with-margin-bottom">
          <button
            [label]="'primeng.upload' | transloco"
            (click)="dispatchClick()"
            pButton
            pRipple
            icon="pi pi-upload"
            class="btn-primary"
          ></button>
          <input
            #fileUploader
            (change)="fileChangeEvent($event)"
            style="display:none;"
            type="file"
            accept="image/*"
          />
        </div>
        <div class="col-12 md:col-4 with-margin-bottom">
          <div>
            <div *ngIf="!image">
              <label *ngIf="!maxSizeErrorMessage || maxSizeErrorMessage == ''" class="fileName">
                {{'forms.noImage' | transloco}}
              </label>
              <label *ngIf="maxSizeErrorMessage && maxSizeErrorMessage != ''" class="p-message-error">
                {{'forms.maxFileSizeMessage' | transloco}} {{maxSizeErrorMessage}}
              </label>
            </div>
            <div *ngIf="image">
              <label class="removeFile">
                <i class="pi pi-times" aria-hidden="true" (click)="removeImage()"></i>
              </label>
              <label class="fileIcon">
                <img src="{{getIcon()}}" class="mr-3" alt="Uploaded image"/>
              </label>
              <label class="fileName">
                {{image.name}}
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancelAction()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
      <p-button
        *ngIf="applicationForm"
        [disabled]="!applicationForm.valid || !isValidFile()"
        [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        (onClick)="persistAssetData()"
        styleClass="button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>

